import React from "react";
import "./BezosSignIn.scss";
import { useAuthenticator } from "@aws-amplify/ui-react";
import {
	Box,
	Button,
	Grid,
	Typography,
	Avatar,
} from "@mui/material";
import { ThemeProvider } from "@mui/material/styles";
import { LightTheme } from "../../utils/baseTheme";

export default {
	Header() {
		return <ThemeProvider theme={LightTheme}>
			<Grid
				id="login-page-header"
				container
				spacing={0}
				direction="column"
				alignItems="center"
				justifyContent="center"
			>

				<Grid item xs={12} lg={12} mb={2}>
					<Avatar
						src={"/logo/gonini-logo-black.svg"}
						alt="Gonini"
						title="Gonini"
						variant="square"
						imgProps={{ style: { objectFit: "contain" } }}
						sx={{ width: "110px", height: "41px", marginTop: "40px", bgcolor: "transparent" }}
					>
					</Avatar>
				</Grid>

				<Grid item xs={12} lg={12} mb={2}>
					<Typography variant="h5" component="h2">
						Seller Portal Sign in
					</Typography>
				</Grid>
			</Grid>
		</ThemeProvider>;
	},
	Footer() {
		const { toResetPassword } = useAuthenticator();

		return <ThemeProvider theme={LightTheme}>
			<Grid item xs={12} lg={12} mt={5} mb={3}>
				<Box textAlign="center">
					<Button
						variant="text"
						type="button"
						onClick={toResetPassword}
					>
						Forgot password?
					</Button>
				</Box>
			</Grid>
		</ThemeProvider>;
	}
};
